<template>
    <div>
        <h2>{{uxTitle}}</h2>
        <v-data-table :headers="listHeaders"
                      :items="listData"
                      :pagination.sync="pagination"
                      class="elevation-1">

            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.counter }}</td>
                <td class="text-xs-left">{{ props.item.account }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.created }}</td>
                <td class="text-xs-left">{{ props.item.code }}</td>

            </template>
        </v-data-table>
    </div>
</template>

<script>

    import firebase from "firebase/compat/app";
    import 'firebase/compat/firestore';

    export default {

        props: ['list_name'],
        data() {
            return {
                uxTitle: "Access List for '" + this.$props.list_name+"'",

                // Tabelle mit den Daten
                listData: [],

                pagination: {
                    sortBy: 'counter',
                    descending: true,
                    rowsPerPage: -1
                },


                listHeaders: [
                    {
                        text: '#',
                        align: 'left',
                        sortable: true,
                        value: '#',
                    },

                    {
                        text: 'Account',
                        align: 'left',
                        value: 'C',
                    },

                    {
                        text: 'E-Mail',
                        align: 'left',
                        sortable: false,
                        value: 'B',
                    },

                    {
                        text: 'Created',
                        align: 'left',
                        sortable: true,
                        value: 'created',
                    },

                    {
                        text: 'Code used',
                        align: 'left',
                        sortable: false,
                        value: 'D',
                    },

                ],



            };
        },

        computed: {

        },

        methods: {

            // Tempor�r, um die Accountinfo an den Us


            getGermanDate(date) {
                let year;
                year = date.getFullYear();

                let month;
                month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1

                let day;
                day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

                let hour;
                hour = date.getHours() + 1 < 10 ? "0" + (date.getHours() + 1) : date.getHours() + 1;

                let minute;
                minute = date.getMinutes() + 1 < 10 ? "0" + (date.getMinutes() + 1) : date.getMinutes() + 1;




                return day + "." + month + "." + year + ",    " + hour + ":" + minute;
            },

            uiEvent(event) {

                switch (event) {

                    case "cancel": // return to landing page
                        this.$router.push({ name: "landing" });
                        return;
                }


            },

            load_access_list(list_name) {

                let dataRef;
                dataRef = firebase.firestore()
                    .collection("access_lists")
                    .doc(list_name)
                    .collection('per_mail')
                    .orderBy("timestamp", "asc")
                    ;

                let tableLine;
                let counter;


                let z = 2;
                dataRef
                    .get()
                    .then(querySnapshot => {

                        this.listData = [];
                        let access_list_entry;
                        counter = 0;

                        querySnapshot.forEach(doc => {
                            counter++;
                            // Iterate through keys

                            access_list_entry = doc.data();

                            tableLine = {
                                counter: counter,
                                email: doc.id,
                                account: access_list_entry.account,
                                created: this.getGermanDate(access_list_entry.timestamp.toDate()),
                                code: access_list_entry.code,
                                timestamp: access_list_entry.timestamp,
                                uid: access_list_entry.uid
                            };

                            this.listData.push(tableLine)

                        });


                    });

            },



        },

        created() {
                console.log("AccessList created...");
               
                this.load_access_list(this.$props.list_name);
        },

        

    }
</script>

